import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var url = httpRequest.urlWithParams;

    if(url.toLowerCase().includes("/orders/search"))
    {
      url = url.replaceAll('_like', '');

      const apiReq = httpRequest.clone({ url: url });
      return next.handle(apiReq);
    }

    return next.handle(httpRequest);
  }
}